/**
 * Add promotion view to localStorage
 */
const promotionNode = document.querySelector('[data-promotion]');

let promotionViews = localStorage.getItem('promotionViews');
promotionViews = promotionViews ? JSON.parse(promotionViews) : {};

Object.keys({ ...promotionViews }).forEach(key => {
    const promotionView = promotionViews[key];

    // Check if promotion view was more than 30 days ago
    if ((new Date() - new Date(promotionView.viewDate)) > (1000 * 60 * 60 * 24 * 30)) {
        delete promotionViews[key];
    }
});

if (promotionNode) {
    const { promotion, promotionTitle, promotionEndDate } = promotionNode.dataset;
    promotionViews[promotion] = { title: promotionTitle, viewDate: new Date(), endDate: new Date(promotionEndDate) }
}

localStorage.setItem('promotionViews', JSON.stringify(promotionViews));
